var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useRef, useMemo, Fragment } from 'react';
import { Menu } from 'modules/Menu';
import { Falcon } from 'modules/macro';
import { pxToRem } from 'modules/spacing';
import { useGeneratedId, useForkedRef } from 'modules/utils';
import { Button, Label, Description } from '../styled';
export const DateInput = forwardRef((props, forwardedRef) => {
    const { value, min, max, locale, timeZone, onChange, label, id: controlledId, description, stretch = false, disabled = false, invalid = false } = props, restProps = __rest(props, ["value", "min", "max", "locale", "timeZone", "onChange", "label", "id", "description", "stretch", "disabled", "invalid"]);
    const buttonRef = useRef(null);
    const forkedButtonRef = useForkedRef(forwardedRef, buttonRef);
    const selectedDateString = useMemo(() => new window.Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone,
    }), [locale, timeZone]);
    const autoId = useGeneratedId('dateinput');
    const id = controlledId || autoId;
    const describedBy = description ? `${id}-description` : undefined;
    const handleChange = (newDate) => {
        // TODO: onChange can sometimes return the wrong date if "timeZone" is different from user timezone
        if (onChange) {
            onChange(newDate);
        }
    };
    const target = (<Button id={id} $stretch={stretch} $invalid={invalid} ref={forkedButtonRef} type="button" disabled={disabled} data-disabled>
      <span>{value ? selectedDateString.format(value) : null}</span>
      <Falcon icon="calendar" $color="swatches.warm.500"/>
    </Button>);
    return (<Fragment>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Menu.Root minWidth={pxToRem(260)} maxWidth={pxToRem(260)} target={target}>
        <Menu.Calendar value={value} locale={locale} timeZone={timeZone} min={min} max={max} onChange={handleChange} {...restProps}/>
      </Menu.Root>
      {description && <Description id={describedBy}>{description}</Description>}
    </Fragment>);
});
